import colors from "resources/theme/colors";
import { SimpleGrid } from "@chakra-ui/layout";
import Card2Horizontal from "components/Cards/Card2Horizontal";
import GraficoClientes from "./components/GraficoClientes";
import { HiUserGroup } from "react-icons/hi";
import { BsFillPersonFill } from "react-icons/bs";
import { MdPersonOff } from "react-icons/md";
import { Image } from "@chakra-ui/react";
import documentEdit from "assets/images/svgs/document-edit.svg";
import useDashboardClientes from "core/features/cliente/hooks/useDashboardClientes";
import useClientesGraficoAdimplencia from "core/features/cliente/hooks/useClientesGraficoAdimplencia";

export default function DashboardClientes() {
  const { data: dashboard, isFetching: isFetchingDashboard } =
    useDashboardClientes();
  const { data: grafico, isFetching: isFetchingGrafico } =
    useClientesGraficoAdimplencia();

  return (
    <>
      <SimpleGrid columns={{ sm: 1, md: 2, lg: 5 }} gap="16px" mb="32px">
        <GraficoClientes
          valorEmdia={grafico?.emDia ?? 0}
          valorInadimplentes={grafico?.inadimplentes ?? 0}
          valorPendente={grafico?.pendentes ?? 0}
          loading={isFetchingGrafico}
        />

        <Card2Horizontal
          icon={<HiUserGroup size={25} color={colors.primary} />}
          color={colors.blue}
          bg={colors.blue200}
          description={"Total de Clientes"}
          title={`${dashboard?.total ?? 0}`}
          loading={isFetchingDashboard}
        />

        <Card2Horizontal
          icon={<BsFillPersonFill size={25} color={colors.green} />}
          color={colors.green}
          bg={colors.green100}
          description={"Clientes Ativos"}
          title={`${dashboard?.ativos ?? 0}`}
          loading={isFetchingDashboard}
        />

        <Card2Horizontal
          icon={<MdPersonOff size={25} color={colors.darkGray} />}
          color={colors.red}
          bg={colors.gray50}
          description={"Clientes Inativos"}
          title={`${dashboard?.inativos ?? 0}`}
          loading={isFetchingDashboard}
        />
        <Card2Horizontal
          icon={<Image src={documentEdit} />}
          color={colors.green}
          bg={colors.green100}
          description={"Contratos Ativos"}
          title={`${dashboard?.contratosAtivos ?? 0}`}
          loading={isFetchingDashboard}
        />
      </SimpleGrid>
    </>
  );
}
